import { memo, useCallback } from "react";

import { useCartActiveProduct } from "@cart/CartActiveProductContext";
import { CartEmptyView } from "@cart/CartEmpty/CartEmpty.view";
import { useSectionSettings } from "@react/sections/Root/SectionSettingsContext";
import { type CartSectionSettings } from "@tablescape/state";

type Props = {
  baseHeading: string;
};

const CartEmptyBase = ({ baseHeading }: Props) => {
  const {
    content: {
      emptyDrawer: { featuredItems, featuredItemsTitle, footerCta, heading },
    },
  } = useSectionSettings<CartSectionSettings>();
  const { toggleCartDrawer } = useCartActiveProduct();

  const handleCloseCartDrawer = useCallback(() => {
    toggleCartDrawer({
      cartDrawerOpen: false,
      cartDrawerUserToggled: false,
    });
  }, [toggleCartDrawer]);

  return (
    <CartEmptyView
      baseHeading={baseHeading}
      featuredItems={featuredItems}
      featuredItemsTitle={featuredItemsTitle}
      footerCta={footerCta}
      handleCloseCartDrawer={handleCloseCartDrawer}
      heading={heading}
    />
  );
};

export const CartEmpty = memo(CartEmptyBase);
